/**
 * @flow
 */

import {
  ON_COST_ITEM_UPDATE,
  ON_COST_ITEMS_SUCCESS,
  CANCEL_ORDER_SUCCESS,
  ON_MY_TICKETS_MOUNT
} from '../actions';

const initialState = [];

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case ON_COST_ITEM_UPDATE:
      const costItemId = action.payload.cost_item.id;
      const newState = state.map(costItem => {
        if (costItem.cost_item.id === costItemId) {
          return action.payload;
        }
        return costItem;
      });

      return newState;

    case ON_COST_ITEMS_SUCCESS:
      const id = action.payload.cost_item.id;
      return state.filter(costItem => costItem.cost_item.id !== id).concat(action.payload);

    case CANCEL_ORDER_SUCCESS:
      return state.map(item => {
        if (action.costItems.includes(item.cost_item.id)) {
          item.cost_item.ticket_state = 'cancelled';
          item.cost_item.state = 'cancelled';
        }
        return item;
      });

    case ON_MY_TICKETS_MOUNT:
      return [];

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/my-tickets/reducers/cost-items.js